import {FaLinkedinIn , FaGithub, FaKaggle} from 'react-icons/fa';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';

import { Link } from 'react-scroll';

const Footer = () => {

    return (
        <footer>
            <Link className="arrowup" to="home" smooth={true} spy={true} offset={0} duration={500}><MdOutlineKeyboardArrowUp/></Link>
            <div class="icon_container">
                <a href="https://www.linkedin.com/in/benjamin-stach-1bb3741b2"><FaLinkedinIn/></a>
                <a href="https://github.com/Benjouzz"><FaGithub/></a>
                <a href="https://www.kaggle.com/benjouzzz"><FaKaggle/></a>
            </div>
            <div class='sep'></div>
            <p>© 2022 - &lt;/&gt; with ❤️ by Benjamin STACH</p>
        </footer>
        );
}

export default Footer;